import JrButton from './JrButton.vue'
import JrButtongroup from './JrButtongroup.vue'
import JrInput from './JrInput.vue'
import JrCheckbox from './JrCheckbox.vue'
import JrSearchgroup from './JrSearchgroup.vue'
import JrLabelwhere from './JrLabelwhere.vue'
import JrTable from './JrTable.vue'
import JrBigtable from './JrBigtable.vue'
import JrBigitemtable from './JrBigitemtable.vue'
import JrSelect from './JrSelect.vue'
import JrDatetime from './JrDatetime.vue'
import JrInputarea from './JrInputarea.vue'
import JrWheremore from './JrWheremore.vue'
import JrInputwhere from './JrInputwhere.vue'
import JrSelectwhere from './JrSelectwhere.vue'
import JrDatetimewhere from './JrDatetimewhere.vue'
import JrInputtable from './JrInputtable.vue'


export default {
    install: (Vue) => {
        Vue.component('jr-button', JrButton)
        Vue.component('jr-buttongroup', JrButtongroup)
        Vue.component('jr-input', JrInput)
        Vue.component('jr-checkbox', JrCheckbox)
        Vue.component('jr-searchgroup', JrSearchgroup)
        Vue.component('jr-labelwhere', JrLabelwhere)
        Vue.component('jr-table', JrTable)
        Vue.component('jr-bigtable', JrBigtable)
        Vue.component('jr-bigitemtable', JrBigitemtable)
        Vue.component('jr-select', JrSelect)
        Vue.component('jr-datetime', JrDatetime)
        Vue.component('jr-inputarea', JrInputarea)
        Vue.component('jr-inputwhere', JrInputwhere)
        Vue.component('jr-wheremore', JrWheremore)
        Vue.component('jr-selectwhere', JrSelectwhere)
        Vue.component('jr-datetimewhere', JrDatetimewhere)
        Vue.component('jr-inputtable', JrInputtable)
    }
}


// WEBPACK FOOTER //
// ./src/components/componentsjr/index.js